var map = {
	"./dashboard_logo": "./app/javascript/images/dashboard_logo.png",
	"./dashboard_logo.png": "./app/javascript/images/dashboard_logo.png",
	"./idle_logo": "./app/javascript/images/idle_logo.jpeg",
	"./idle_logo.jpeg": "./app/javascript/images/idle_logo.jpeg",
	"./monster": "./app/javascript/images/monster.png",
	"./monster.png": "./app/javascript/images/monster.png"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "./app/javascript/images sync recursive ^\\.\\/.*$";